import { getUserList } from 'services/UserApi';

import { isArray } from 'util/utils';

const initialState = {};

export const UserActionTypes = {
  START_LOADING: 'START_LOADING',
  STOP_LOADING: 'STOP_LOADING',
  SET_EDIT_USER: 'SET_EDIT_USER',
  SET_USERS_LIST: 'SET_USERS_LIST',
  GET_USERS_LIST: 'GET_USERS_LIST',
};

export const UserActions = {
  startLoading: () => ({ type: UserActionTypes.START_LOADING }),
  stopLoading: () => ({ type: UserActionTypes.STOP_LOADING }),
  setEditUser: (user) => ({
    type: UserActionTypes.SET_EDIT_USER,
    payload: user,
  }),
  setUsersList: (id, list, count) => ({
    type: UserActionTypes.SET_USERS_LIST,
    payload: { id, list, count },
  }),
  getUsersList: (id, page, limit) => async (dispatch) => {
    dispatch({ type: UserActionTypes.START_LOADING });

    const [, res] = await getUserList({
      page,
      limit,
      sort: [{ name: 'ASC' }],
      filter: { account: id },
    });

    const list = res?.data?.list;
    return dispatch({
      type: UserActionTypes.SET_USERS_LIST,
      payload: { id, list: res?.code === 'OK' && isArray(list) ? list : [], count: res?.data?.count },
    });
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UserActionTypes.START_LOADING:
      return { ...state, loading: true };

    case UserActionTypes.STOP_LOADING:
      return { ...state, loading: false };

    case UserActionTypes.SET_EDIT_USER:
      return { ...state, editUser: payload, loading: false };

    case UserActionTypes.SET_USERS_LIST:
      return { ...state, [payload?.id]: payload?.list, count: payload?.count, loading: false };

    case '@@RESET':
      return { ...initialState };

    default:
      return { ...state };
  }
};
